import { render, staticRenderFns } from "./reset-sealname.vue?vue&type=template&id=e18d34de&scoped=true&"
import script from "./reset-sealname.vue?vue&type=script&lang=js&"
export * from "./reset-sealname.vue?vue&type=script&lang=js&"
import style0 from "./reset-sealname.vue?vue&type=style&index=0&id=e18d34de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18d34de",
  null
  
)

export default component.exports